import styled from 'styled-components'

export const DropDownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin-top: 24px;
  margin-bottom: 20px;
  gap: 24px;
`

export const StyledItemWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  border: 2px solid #90258c;
`

export const DropdownTile = styled.div`
  /* width: 800px;
  max-width: 100%; */
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  min-height: 50px;
  background-color: #90258c;
  border: 2px solid #90258c;
  display: flex;
  align-items: center;
  padding: 0 20px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  color: #fff;
  font-size: 24px;
  font-weight: 700;
`

export const DropdownTileContent = styled.div`
  width: 100%;

  padding: 0 20px 20px 20px;
`
